import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVariables: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconVariables"><Path fillRule="evenodd" clipRule="evenodd" d="M20.9779 6.8168L12.0007 1.63379L3.02344 6.8168V17.1828L12.0007 22.3658L20.9779 17.1828V6.8168ZM9.75073 11.9998C9.75073 10.7571 10.7581 9.74976 12.0007 9.74976C13.2434 9.74976 14.2507 10.7571 14.2507 11.9998C14.2507 13.2424 13.2434 14.2498 12.0007 14.2498C10.7581 14.2498 9.75073 13.2424 9.75073 11.9998Z" fill="currentColor"/></CentralIconBase>;
});

export default IconVariables;
